<div
  class="banner-with-text"
  [ngStyle]="{ 'background-image': 'url(assets/images/meet-the-team.jpg)' }"
>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1 class="hdg">Meet the Team</h1>
      </div>
    </div>
  </div>
</div>

<div class="public-wrap">
  <div class="container">
    <div class="public-wrap-inner">
      <div class="row">
        <div class="col-12">
          <h1 class="teamHdgTop text-center">
            “Coming together is a <strong>beginning,</strong> staying together
            is <strong>progress,</strong> and working together is
            <strong>success.</strong>”
          </h1>
          <p class="our-team-des text-center">- Henry Ford</p>
        </div>
      </div>

      <div class="row justify-content-center">
        <div
          class="col-sm-6 col-md-6 col-xl-3 team-list-part"
          *ngFor="let data of responseData"
        >
          <div class="top-wrap">
            <div class="top-wrap-inner">
              <img
                alt="team-member"
                class="team-member"
                src="{{ data.profileImage }}"
              />
              <a
                class="view-arrow cursor-pointer"
                role="button"
                (click)="showTeamMemberDetail(data.id, template)"
              >
                <img
                  alt="team-member"
                  class="view-more"
                  src="/assets/images/arrow_red.svg"
                />
              </a>
            </div>
          </div>
          <div class="btm-wrap">
            <div class="team-social">
              <a [href]="'mailto:' + data.email" *ngIf="data.email != null">
                <img
                  alt="social-links"
                  class="social-icons-member"
                  src="/assets/images/email-white.svg"
                />
              </a>
              <a
                [href]="data.profileLink"
                *ngIf="data.profileLink != null"
                target="_blank"
              >
                <img
                  alt="social-links"
                  class="social-icons-member"
                  src="/assets/images/linkedin-white.svg"
                />
              </a>
            </div>
            <div class="team-detail">
              <h1 class="name">{{ data.name }}</h1>
              <h3 class="designation">{{ data.designation }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <img alt="team" class="teamMem" src="/assets/images/teamMembers.jpg" />
      </div>
    </div>
  </div>
</div>

<ng-template #template>
  <div class="member-wrap">
    <div class="image-wrap">
      <div class="top-part">
        <img
          alt="team-member"
          class="team-member img-fluid"
          src="{{ viewDetails.profileImage }}"
        />
      </div>
      <div class="btn-part">
        <a
          style="text-decoration: none"
          [href]="viewDetails.profileLink"
          *ngIf="viewDetails.profileLink != null"
          target="_blank"
        >
          <button type="button" class="btn btn-popup w-100 mb-3">
            <img class="btn-icon" src="/assets/images/linkedin-white2.svg" />
            Follow On Linkedin
          </button></a
        >
        <a
          style="text-decoration: none"
          [href]="'mailto:' + viewDetails.email"
          *ngIf="viewDetails.email != null"
          ><button type="button" class="btn btn-popup btn-yellow w-100">
            Send Email
          </button></a
        >
      </div>
    </div>
    <div class="des-wrap">
      <div class="close-icon-wrap">
        <button
          type="button "
          class="close circle-icon"
          aria-label="Close "
          role="button"
          (click)="modalRef.hide()"
        >
          <img src="../assets/images/cross.svg " />
        </button>
      </div>

      <div class="name-wrap">
        <h1 class="name"
        [matTooltip]="viewDetails.name"
        [matTooltipPosition]="'above'">
        {{ viewDetails.name }}
        </h1>
        <h1 class="post">{{ viewDetails.designation }}</h1>
      </div>
      <div class="dtl-wrap">
        <p [innerHTML]="viewDetails.description"></p>
      </div>
    </div>
  </div>
</ng-template>
